<template>
  <div v-if="!this.user.loading">
    <v-container v-if="this.user.department.departmentid !== undefined">
      <v-row no-gutters>
        <div v-for="(service, i) in user.department.services" :key="i + service.jobcode" class="col-12 col-sm-6 col-md-4 col-lg-4">
          <ItemService
            :key="service.jobcode"
            :item="service"
            v-on:childToParent="servicesToggle"
            :selected="user.services.some((e) => e.jobcode === service.jobcode)"
            :isOpenProp="itemOpen == service"
            v-on:stateOpenItemToParent="stateOpenItem"
          />
        </div>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import ItemService from './fragments/itemService';
import helpers from '@/settings/helpers';
import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters } = createNamespacedHelpers('user');

export default Vue.extend({
  name: 'ListServices',
  methods: {
    servicesToggle(item) {
      const inArray =
        this.user.services.filter((itm) => {
          return itm.jobcode === item.jobcode;
        }).length > 0;
      const eventAction = inArray ? 'service-removed' : 'service-added';
      const dataLayerData = {
        event: 'easybooking-click',
        eventCategory: 'services',
        eventAction: eventAction,
        serviceJobCode: item.jobcode,
        serviceJobDescription: item.jobdescription,
        serviceJobPrice: item.jobprice,
        serviceJobTime: item.jobtime
      };
      helpers.sendGTM(dataLayerData, this.user.config.host);
      this.$store.dispatch('user/initServices', item).then(() => {
        this.$store.dispatch('user/initServicesTime', this.setTotalTime());
        this.$store.dispatch('user/initLoading', true);
        this.$store.dispatch('user/initLoading', false);
      });
    },
    stateOpenItem(data) {
      this.itemOpen = data.state ? data.item : null;
    },
    setTotalTime() {
      let time = 0;
      this.user.services.forEach((item) => {
        time += item.jobtime;
      });

      let hours = time / 60;
      let rhours = Math.floor(hours);
      let minutes = (hours - rhours) * 60;
      let rminutes = Math.round(minutes);
      let data = { hours: rhours, minutes: rminutes };
      return data;
    },
    commentsAreDisabled(commentsAreDisabledValue) {
      if(commentsAreDisabledValue == null || commentsAreDisabledValue === 'false') return false;
      
      return commentsAreDisabledValue;
    }
  },
  data() {
    return {
      itemOpen: null
    };
  },
  components: {
    ItemService
  },
  computed: {
    ...mapGetters(['user'])
  }
});
</script>

<style scoped lang="scss"></style>

<i18n src="../localization/texts.json"></i18n>
